import Footer from "../components/Footer";

const Contact = () => {
  return (
    <>
      <main className="page-shell contact-page">
        <section className="contact-hero">
          <div className="section-container">
            <p className="eyebrow">Contact</p>
            <h1>We’d love to hear from you</h1>
            <p className="hero-text">Questions about products, orders, or ingredients? Drop us a note — we typically respond within 48 hours.</p>
          </div>
        </section>

        <section className="section-container contact-layout">
          <div className="contact-left">
            <div className="form-card">
              <h3>Send a message</h3>
              <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
                <div className="field-row">
                  <label>
                    <span>Name</span>
                    <input type="text" name="name" placeholder="Your name" />
                  </label>

                  <label>
                    <span>Email</span>
                    <input type="email" name="email" placeholder="you@example.com" />
                  </label>
                </div>

                <label>
                  <span>Subject</span>
                  <input type="text" name="subject" placeholder="Order / Product / Other" />
                </label>

                <label>
                  <span>Message</span>
                  <textarea name="message" placeholder="How can we help?" />
                </label>

                <div className="form-actions">
                  <button className="primary-btn" type="submit">Send message</button>
                  <button className="secondary-btn" type="button">Clear</button>
                </div>
              </form>
            </div>
          </div>

          <aside className="contact-right">
            <div className="contact-card">
              <h4>Customer care</h4>
              <p>Email: <a href="mailto:hello@vedaglow.com">hello@vedaglow.com</a></p>
              <p>Phone: <a href="tel:+911234567890">+91 12345 67890</a></p>
              <p>Mon — Fri: 9am — 6pm IST</p>
            </div>

            <div className="contact-card">
              <h4>Visit us</h4>
              <address>
                VEDA GLOW Ltd.<br />
                12 Ritual Lane<br />
                Bangalore, KA 560001
              </address>
            </div>

            <div className="contact-card">
              <h4>Follow</h4>
              <div className="social-links">
                <a href="#/">Instagram</a>
                <a href="#/">Facebook</a>
                <a href="#/">YouTube</a>
              </div>
            </div>
          </aside>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Contact;
